
export default "/assets/tag-micro.5f924b2a.svg"